export default ({ color, selected, onClick, tabIndex }) => {
  return (
    <button
      className="canvas-color-button"
      tabIndex={tabIndex}
      style={
        selected
          ? {
              borderColor: "#069DDE",
              borderWidth: 2,
              borderStyle: "solid",
              backgroundColor: color,
            }
          : { backgroundColor: color }
      }
      onClick={() => onClick(color)}
    />
  );
};
